import { Column } from '@/types';

export default [
  {
    text: 'office.tables.headers.ID',
    title: 'office.tables.headers.id',
    align: 'left',
    sortable: false,
    value: 'id',
    width: 50,
  },
  { value: 'name', text: `office.tables.headers.installer` },
] as Column[];
